import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryProvider } from './providers/QueryProvider';
import App from './App';
import { AuthInitializer } from './components/common/AuthInitializer';
import './index.css';

// PWA service worker registration with error handling
import { registerSW } from 'virtual:pwa-register';

registerSW({
  onRegisteredSW(swUrl) {
    console.log('[SW] Registered:', swUrl);
  },
  onRegisterError(error) {
    console.error('[SW] Registration failed:', error);
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryProvider>
      <BrowserRouter>
        <AuthInitializer />
        <App />
      </BrowserRouter>
    </QueryProvider>
  </React.StrictMode>
);
